(function () {
  function formatMoney(cents, currencySymbol) {
    if (cents == null || Number.isNaN(Number(cents))) return '';
    return (currencySymbol || '$') + (Number(cents) / 100).toFixed(2);
  }

  function parseProductData(root) {
    const dataNodes = root.querySelectorAll('.ffpp-product-data');
    const products = [];

    dataNodes.forEach((node) => {
      try {
        const parsed = JSON.parse(node.textContent);
        products.push(parsed);
      } catch (error) {
        console.error('[ffpp] Failed to parse product JSON', error);
      }
    });

    return products;
  }

  function initSection(root) {
    const products = parseProductData(root);
    if (!products.length) return;

    const currencySymbol = root.dataset.currencySymbol || '$';
    const sticksPerBag = Number(root.dataset.sticksPerBag) || 12;
    const cartAddUrl = root.dataset.cartAddUrl || '/cart/add';
    const showDeliveryFrequency = root.dataset.showDeliveryFrequency === 'true';

    const flavorButtons = Array.from(root.querySelectorAll('.ffpp-flavor'));
    const packRadios = Array.from(root.querySelectorAll('.ffpp-pk-radio'));
    const form = root.querySelector('.ffpp-form');
    const variantInput = root.querySelector('.ffpp-variant-input');
    const sellingPlanInput = root.querySelector('.ffpp-selling-plan-input');
    const quantityInput = root.querySelector('.ffpp-quantity-input');
    const sellingPlanSelect = root.querySelector('.ffpp-selling-plan-select');
    const ctaButton = root.querySelector('.ffpp-cta-btn');
    const ctaText = root.querySelector('.ffpp-cta-text');
    const ctaPrice = root.querySelector('.ffpp-cta-price');
    const buyOnceButton = root.querySelector('.ffpp-buy-once-link');
    const buyOncePrice = root.querySelector('.ffpp-buy-once-price');
    const buyOnceSuffix = root.querySelector('.ffpp-buy-once-suffix');
    const freeShippingThreshold = Number(root.dataset.freeShippingThreshold) || 0;
    const titleEl = root.querySelector('.ffpp-title');
    const subtitleEl = root.querySelector('.ffpp-subtitle');
    const galleries = Array.from(root.querySelectorAll('[data-ffpp-gallery]'));
    const stickyBar = root.querySelector('.ffpp-sticky-cta');
    const stickyImg = root.querySelector('.ffpp-sticky-cta__img');
    const stickyTitle = root.querySelector('.ffpp-sticky-cta__title');
    const stickyPrice = root.querySelector('.ffpp-sticky-cta__price');
    const stickyBtn = root.querySelector('.ffpp-sticky-cta__btn');

    let currentProductIndex = Math.max(
      flavorButtons.findIndex((btn) => btn.classList.contains('is-active')),
      0
    );

    function getActiveProduct() {
      return products[currentProductIndex] || products[0];
    }

    function getSelectedPackRadio() {
      return packRadios.find((radio) => radio.checked) || packRadios[0];
    }

    function getSelectedRechargePercent() {
      if (showDeliveryFrequency && sellingPlanSelect && !sellingPlanSelect.disabled && sellingPlanSelect.options.length) {
        const selected = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
        return Number(selected?.dataset.discount || 0);
      }
      return Number(sellingPlanInput?.dataset.discount || 0);
    }

    function isThirtyDayPlan(planName) {
      const normalized = String(planName || '').toLowerCase();
      const hasThirty = normalized.includes('30');
      const hasDay = normalized.includes('day');
      return hasThirty && hasDay;
    }

    function findLockedPlan(product) {
      if (!product?.sellingPlans?.length) return null;
      return product.sellingPlans.find((plan) => isThirtyDayPlan(plan.name)) || null;
    }

    function updatePackRadiosWithVariantPrice(newVariantPrice, newCompareAtPrice) {
      packRadios.forEach((radio) => {
        const packSize = Number(radio.dataset.packSize) || 1;
        const multidiscountPercent = Number(radio.dataset.multidiscountPercent) || 0;
        const totalPrice = Number(newVariantPrice) * packSize;
        const priceAfterMultidiscount = Math.round(totalPrice * (1 - multidiscountPercent / 100));

        radio.dataset.baseVariantPrice = String(Number(newVariantPrice) || 0);
        radio.dataset.baseCompareAtPrice = String(Number(newCompareAtPrice) || 0);
        radio.setAttribute('base-price', String(priceAfterMultidiscount));
        radio.setAttribute('price', formatMoney(priceAfterMultidiscount, currencySymbol));
      });
    }

    function updateSavingsBadges() {
      const rechargePercent = getSelectedRechargePercent();

      packRadios.forEach((radio) => {
        const card = radio.nextElementSibling;
        if (!card) return;
        const discountBadge = card.querySelector('.ffpp-pack-discount');
        const multidiscountPercent = Number(radio.dataset.multidiscountPercent) || 0;
        const effectiveDiscount = Math.round((1 - (1 - rechargePercent / 100) * (1 - multidiscountPercent / 100)) * 100);

        if (!discountBadge) return;

        if (effectiveDiscount > 0) {
          discountBadge.textContent = `${effectiveDiscount}% OFF`;
          discountBadge.style.display = '';
        } else {
          discountBadge.textContent = '';
          discountBadge.style.display = 'none';
        }
      });
    }

    function recalculatePackPrices() {
      const rechargePercent = getSelectedRechargePercent();
      const selectedRadio = getSelectedPackRadio();

      packRadios.forEach((radio) => {
        const card = radio.nextElementSibling;
        if (!card) return;

        const packSize = Number(radio.dataset.packSize) || 1;
        const multidiscountPercent = Number(radio.dataset.multidiscountPercent) || 0;
        const baseVariantPrice = Number(radio.dataset.baseVariantPrice) || 0;
        const totalPrice = baseVariantPrice * packSize;
        const priceAfterMultidiscount = Math.round(totalPrice * (1 - multidiscountPercent / 100));
        const subscribePrice = Math.round(priceAfterMultidiscount * (1 - rechargePercent / 100));
        const perServing = sticksPerBag > 0 ? subscribePrice / (packSize * sticksPerBag) : 0;

        const servingEl = card.querySelector('.ffpp-pack-serving');
        const compareEl = card.querySelector('.ffpp-pack-compare');
        const priceEl = card.querySelector('.ffpp-pack-price');

        if (servingEl) {
          const servingSuffix = card.dataset.perServingLabel || 'per serving';
          servingEl.textContent = `${formatMoney(perServing, currencySymbol)} ${servingSuffix || 'per serving'}`;
        }

        if (compareEl) {
          if (totalPrice > subscribePrice) {
            compareEl.textContent = formatMoney(totalPrice, currencySymbol);
            compareEl.style.display = '';
          } else {
            compareEl.textContent = '';
            compareEl.style.display = 'none';
          }
        }

        if (priceEl) {
          priceEl.textContent = formatMoney(subscribePrice, currencySymbol);
        }
      });

      if (selectedRadio) {
        const packSize = Number(selectedRadio.dataset.packSize) || 1;
        const multidiscountPercent = Number(selectedRadio.dataset.multidiscountPercent) || 0;
        const baseVariantPrice = Number(selectedRadio.dataset.baseVariantPrice) || 0;
        const totalPrice = baseVariantPrice * packSize;
        const oneTimePrice = Math.round(totalPrice * (1 - multidiscountPercent / 100));
        const subscribePrice = Math.round(oneTimePrice * (1 - rechargePercent / 100));

        if (quantityInput) quantityInput.value = String(packSize);
        if (ctaPrice) ctaPrice.textContent = formatMoney(subscribePrice, currencySymbol);
        if (buyOncePrice) buyOncePrice.textContent = formatMoney(oneTimePrice, currencySymbol);

        if (buyOnceSuffix) {
          const qualifiesForFreeShipping =
            freeShippingThreshold > 0 && oneTimePrice >= freeShippingThreshold;
          buyOnceSuffix.hidden = qualifiesForFreeShipping;
          if (!qualifiesForFreeShipping) {
            buyOnceSuffix.textContent = buyOnceSuffix.dataset.defaultText || '';
          }
        }
      }

      updateSavingsBadges();
      syncStickyBar();
    }

    function syncStickyBar() {
      if (!stickyBar) return;
      const product = getActiveProduct();
      if (stickyTitle && titleEl) stickyTitle.textContent = titleEl.textContent;
      if (stickyPrice && ctaPrice) stickyPrice.textContent = ctaPrice.textContent;
      if (stickyImg && product.image) {
        stickyImg.src = product.image;
        stickyImg.alt = product.title || '';
      }
    }

    function rebuildSellingPlans(product) {
      if (!sellingPlanInput) return;

      if (!showDeliveryFrequency) {
        const lockedPlan = findLockedPlan(product);
        if (!lockedPlan) {
          sellingPlanInput.value = '';
          sellingPlanInput.dataset.discount = '0';
          return;
        }
        sellingPlanInput.value = String(lockedPlan.id);
        sellingPlanInput.dataset.discount = String(lockedPlan.discount || 0);
        return;
      }

      if (!sellingPlanSelect) return;
      const previousPlan = sellingPlanSelect.value;
      sellingPlanSelect.innerHTML = '';

      if (!product.sellingPlans || !product.sellingPlans.length) {
        sellingPlanSelect.disabled = true;
        sellingPlanInput.value = '';
        sellingPlanInput.dataset.discount = '0';
        return;
      }

      sellingPlanSelect.disabled = false;

      product.sellingPlans.forEach((plan) => {
        const option = document.createElement('option');
        option.value = String(plan.id);
        option.dataset.discount = String(plan.discount || 0);
        option.textContent = plan.name;
        sellingPlanSelect.appendChild(option);
      });

      const hasPrevious = Array.from(sellingPlanSelect.options).some((option) => option.value === previousPlan);
      sellingPlanSelect.value = hasPrevious ? previousPlan : String(product.sellingPlans[0].id);
      sellingPlanInput.value = sellingPlanSelect.value;
      const selected = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
      sellingPlanInput.dataset.discount = String(selected?.dataset.discount || 0);
    }

    function updateAvailability(product) {
      const hasRequiredSellingPlan = Boolean(sellingPlanInput?.value);
      const isAvailable = product.available !== false && hasRequiredSellingPlan;
      if (ctaButton) ctaButton.disabled = !isAvailable;
      if (buyOnceButton) buyOnceButton.disabled = !isAvailable;

      if (ctaText) {
        if (!hasRequiredSellingPlan && !showDeliveryFrequency) {
          ctaText.textContent = '30-DAY PLAN UNAVAILABLE';
        } else {
          ctaText.textContent = isAvailable ? ctaText.dataset.defaultText || ctaText.textContent : 'SOLD OUT';
        }
      }
    }

    function resetGalleryToFirstSlide(gallery) {
      if (!gallery) return;
      const slideshow = gallery.querySelector('slideshow-component');
      if (!slideshow || typeof slideshow.select !== 'function') return;
      slideshow.select(0, undefined, { animate: false });
    }

    function updateActiveGallery() {
      galleries.forEach((gallery, idx) => {
        const isActive = idx === currentProductIndex;
        gallery.classList.toggle('is-active', isActive);
        gallery.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        gallery.style.display = isActive ? '' : 'none';
        if (isActive) {
          gallery.removeAttribute('hidden');
          resetGalleryToFirstSlide(gallery);
        } else {
          gallery.setAttribute('hidden', '');
        }
      });
    }

    function setActiveFlavor(index) {
      currentProductIndex = index;
      const product = getActiveProduct();

      flavorButtons.forEach((button, idx) => {
        const isActive = idx === currentProductIndex;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });

      if (titleEl) titleEl.textContent = product.title || '';
      if (subtitleEl) subtitleEl.textContent = product.subtitle || '';
      updateActiveGallery();
      if (variantInput) variantInput.value = String(product.variantId || '');

      rebuildSellingPlans(product);
      updatePackRadiosWithVariantPrice(Number(product.price) || 0, Number(product.compareAtPrice) || 0);
      recalculatePackPrices();
      updateAvailability(product);
    }

    function dispatchCartUpdate(resultBody) {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: resultBody,
            sourceId: `ffpp-${root.dataset.ffppSection || 'section'}`,
            data: {}
          }
        })
      );
    }

    function submitAddToCart(includeSellingPlan) {
      const product = getActiveProduct();
      const selectedPack = getSelectedPackRadio();

      if (!product || !selectedPack) return;
      if (ctaButton && ctaButton.disabled) return;

      const quantity = Number(selectedPack.dataset.packSize) || 1;
      const formData = new FormData();
      formData.append('id', String(product.variantId));
      formData.append('quantity', String(quantity));

      if (includeSellingPlan && sellingPlanInput && sellingPlanInput.value) {
        formData.append('selling_plan', String(sellingPlanInput.value));
        // Functions app: query attribute(key: "_free_shipping_promo") on cart lines
        formData.append('properties[_free_shipping_promo]', 'fiber-flow-landing-b');
      }

      formData.append('sections_url', window.location.pathname);

      const buttonToLock = includeSellingPlan ? ctaButton : buyOnceButton;
      const previousText = includeSellingPlan && ctaText ? ctaText.textContent : '';

      if (buttonToLock) buttonToLock.disabled = true;
      if (includeSellingPlan && ctaText) ctaText.textContent = 'ADDING...';

      fetch(`${cartAddUrl}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then((response) => response.json().then((body) => ({ ok: response.ok, body })))
        .then((result) => {
          if (!result.ok) {
            throw new Error(result.body?.description || 'Unable to add to cart');
          }
          dispatchCartUpdate(result.body);
        })
        .catch((error) => {
          console.error('[ffpp] add to cart failed', error);
          if (includeSellingPlan && ctaText) ctaText.textContent = 'TRY AGAIN';
          setTimeout(() => {
            if (includeSellingPlan && ctaText) ctaText.textContent = previousText;
          }, 1500);
        })
        .finally(() => {
          if (buttonToLock) buttonToLock.disabled = false;
          if (includeSellingPlan && ctaText && ctaText.textContent === 'ADDING...') {
            ctaText.textContent = previousText;
          }
        });
    }

    if (ctaText) ctaText.dataset.defaultText = ctaText.textContent;
    if (buyOnceSuffix) buyOnceSuffix.dataset.defaultText = buyOnceSuffix.textContent;

    flavorButtons.forEach((button, index) => {
      button.addEventListener('click', () => setActiveFlavor(index));
    });

    packRadios.forEach((radio) => {
      radio.addEventListener('change', recalculatePackPrices);
    });

    if (sellingPlanSelect) {
      sellingPlanSelect.addEventListener('change', () => {
        if (sellingPlanInput) {
          sellingPlanInput.value = sellingPlanSelect.value;
          const selected = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
          sellingPlanInput.dataset.discount = String(selected?.dataset.discount || 0);
        }
        recalculatePackPrices();
        updateAvailability(getActiveProduct());
      });
    }

    if (form) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        submitAddToCart(true);
      });
    }

    if (buyOnceButton) {
      buyOnceButton.addEventListener('click', () => submitAddToCart(false));
    }

    if (stickyBar && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            stickyBar.classList.toggle('is-visible', scrolledPast);
            stickyBar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
          });
        },
        { threshold: 0 }
      );
      observer.observe(root);
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const headerOffset =
          parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
        const top = root.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    }

    setActiveFlavor(currentProductIndex);
  }

  function boot() {
    const sections = document.querySelectorAll('[data-ffpp-section]');
    sections.forEach((section) => initSection(section));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
